<template>
  <div>
    <SectionSeparatorWrapper :separator="false" headerText="Order member cards" headerRequiredFieldsText="Indicates required field">
      <div class="form-section field">
        <Alert v-if="hideAddress" :message="privacyMessage" alertType="info" />
        <FormField labelText="Number of cards to be sent" forId="number-of-cards">
          <DropdownSelect v-model="selectedNumberOfCards" :items="dropdownItems" id="number-of-cards" :initialSelect="selectedNumberOfCards" />
        </FormField>
      </div>
      <div class="form-section field" v-if="!hideAddress">
        <FormField labelText="Postal address" forId="postal-address" :required="false">
          <textarea id="postal-address" readOnly :value="postalAddress" />
        </FormField>
      </div>
    </SectionSeparatorWrapper>
    <div class="form-page-nav">
      <section class="next-button-margin">
        <button @click="handleNextButton" :disabled="navDisabled">Next</button>
      </section>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { Alert, FormField, SectionSeparatorWrapper } from '@/components';
import DropdownSelect from '@general/js/components/DropdownSelect.vue';

export default {
  name: 'StepOrderMemberCard',

  components: {
    Alert,
    FormField,
    SectionSeparatorWrapper,
    DropdownSelect,
  },

  props: {
    numberOfCards: {
      type: String,
      required: true,
    },

    postalAddress: {
      type: String,
      required: true,
    },

    navDisabled: {
      type: Boolean,
      required: true,
    },

    handleNextButton: {
      type: Function,
      required: true,
    },

    hideAddress: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedNumberOfCards: this.numberOfCards === '' ? 'Select number of cards' : this.numberOfCards,
      privacyMessage: 'Cards will be sent to the Policy holder’s postal or residential address, as you haven’t nominated a postal address.',
    };
  },

  computed: {
    dropdownItems() {
      return [...Array(5)].map((_, i) => {
        return { name: i + 1 };
      });
    },
  },

  watch: {
    selectedNumberOfCards(newVal) {
      this.handleUpdate(newVal);
    },
  },

  methods: {
    ...mapMutations('GenerateMemberCards', ['updateNumberOfCards']),

    /**
     * Handle the update of the number of cards.
     */
    handleUpdate(newValue) {
      this.updateNumberOfCards(newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.next-button-margin {
  margin-bottom: 80px;
}

.box.alert {
  margin-top: rem(10);
  max-width: 503.33px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
